/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'cross': {
    width: 16,
    height: 16,
    viewBox: '0 0 12 12',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M4.659 6L0 1.341 1.341 0 6 4.659 10.659 0 12 1.341 7.341 6 12 10.659 10.659 12 6 7.341 1.341 12 0 10.659 4.659 6z" _fill="#E63A2B" fill-rule="nonzero"/></g>'
  }
})
